import ReactDOM from "react-dom/client";
import { unstable_HistoryRouter as Router } from "react-router-dom";
import { RecoilRoot } from "recoil";
import App from "./App";
import { history } from "./history";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <RecoilRoot>
    <Router history={history}>
      <App />
    </Router>
  </RecoilRoot>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
